exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv[data-v-953a120a] .edit-btn {\n  margin-top: 0px;\n  margin-left: 3px;\n}\ndiv[data-v-953a120a] .v-btn.edit-btn .v-btn__content .v-icon {\n  font-size: 17px;\n  color: #6b6868;\n}\ndiv[data-v-953a120a] .secondary-text {\n  color: #6b6868;\n  margin-top: 5px;\n  font-size: 11px;\n  padding-left: 4px;\n}\n", ""]);

